import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationautoscheduling'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetByRegulationAuto = (id, data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}`, data, config)
const GetLastByRegulationAuto = (regulationautoid, data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${regulationautoid}/lastscheduling`, data, config)
const GetActiveByRegulationAuto = (regulationautoid, data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${regulationautoid}/active`, data, config)
const GetByRegulationAutoPaging = (id, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const RegulationAutoSchedulingRepository = {
  GetAll,
  GetAllPaging,
  GetByRegulationAuto,
  GetByRegulationAutoPaging,
  GetLastByRegulationAuto,
  GetActiveByRegulationAuto,
  GetById,
  Create,
  Update,
  Delete
}

export default RegulationAutoSchedulingRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautoscheduling.js